import React, { useState } from 'react';
import { Typography, Box, Button, Grid, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { VERSION } from '../../constants/version';
import Layout from '../shared/components/LayoutComponent';
import MessageBox from '../shared/components/MessageBox';
import { useTranslation } from 'react-i18next';
import { FullPageSpinner } from '../../components/lib';
import { useAdmin } from '../../context/admin-context';
import { usePlatform } from '../../context/platform-context';
import {LOCAL_STORAGE_KEY} from '../../constants/localStorage';

function isElectron() {
  // Renderer process
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
    return true;
  }

  // Main process
  if (typeof process !== 'undefined' && typeof process?.versions === 'object' && !!process?.versions.electron) {
    return true;
  }

  // Detect the user agent when the `nodeIntegration` option is set to true
  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
    return true;
  }

  return false;
}

function NewVersion({ latestVersion }) {
  const { t } = useTranslation();
  const { isWindows, isMac } = usePlatform()
  const { isAdmin } = useAdmin()
  const [deviceVersion,] = useState(localStorage.getItem(LOCAL_STORAGE_KEY.version) || VERSION);
  const [hideMessage, setHideMessage] = useState(false);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [spinner, setSpinner] = useState(false);
  if (window.cordova) return null;
  if (!latestVersion || latestVersion === "") return null;
  if (isAdmin) return null;
  if (hideMessage) return null;
  if (!isElectron()) return null;
  var link = null;

  if (isWindows) {
    link = 'https://www.ectool.de/download/ectool-app-win64.exe'
  } else if (isMac) {
    link = 'https://www.ectool.de/download/ectool-app-mac.pkg'
  } else {
    link = 'https://www.ectool.de/download/ectool-app-win64.exe'
  }

  const startDownload = () => {
    const linkElement = document.createElement('a');
    linkElement.href = link;
    linkElement.download = true;
    document.body.appendChild(linkElement);
    linkElement.click();
    document.body.removeChild(linkElement);
  }

  const openMessageBox = () => {
    setShowMessageBox(true);
  }

  const closeMessageBox = () => {
    setShowMessageBox(false);
  }

  const showSpinner = () => {
    setSpinner(true);
  }

  const messageBoxResult = (result) => {
    closeMessageBox();
    if (result === 'YES') {
      showSpinner();
      startDownload();
    }
  }

  if (deviceVersion < latestVersion) {
    return (
      <Layout>
        <Box p={2}>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography variant="h4">{t('Neue Version')}</Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={() => setHideMessage(true)}><CloseIcon /></IconButton></Grid>
            <Grid item xs={12}>
              <Typography variant="body1">{t("Es ist eine neue Version {{currentVersion}} der ectool-app verfügbar", {currentVersion: "("+latestVersion+")"})}</Typography>
            </Grid>
            {link &&
              <Grid item xs={12} justifyContent="flex-end">
                <Button variant="contained" color="primary" onClick={openMessageBox}>{t("Jetzt herunterladen")}</Button>
              </Grid>
            }
          </Grid>
        </Box>
        <MessageBox
          open={showMessageBox}
          handleResponse={messageBoxResult}
          buttons="YESNO"
          text={t("Das Aktualisieren der App kann einige Minuten dauern. Wollen Sie den Download jetzt starten?")}
          title={t("Hinweis")}
          onClose={() => closeMessageBox()}
        />
        {spinner && <FullPageSpinner />}
      </Layout>
    )
  }
  return null
}

export default NewVersion;
